import types from '../mutation-types';
import CsatSurveysAPI from '../../api/csatSurveys';

export const state = {
  records: {},
  formats: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getCsatSurveys(_state) {
    return Object.values(_state.records);
  },
  getSurveyById(_state) {
    return id => _state.records[Number(id)];
  },
  getFormats(_state) {
    return _state.formats;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getCsatSurveys({ commit }) {
    commit(types.SET_CSAT_SURVEY_UI_FLAG, { isFetching: true });
    try {
      const { data } = await CsatSurveysAPI.get();
      commit(types.SET_CSAT_SURVEYS, data.payload);
    } finally {
      commit(types.SET_CSAT_SURVEY_UI_FLAG, { isFetching: false });
    }
  },
  show: async function showCsatSurvey({ commit }, id) {
    const { data } = await CsatSurveysAPI.show(id);
    commit(types.SET_CSAT_SURVEY, data);
  },
  update: async function updateCsatSurvey({ commit }, { id, ...payload }) {
    commit(types.SET_CSAT_SURVEY_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await CsatSurveysAPI.update(id, {
        csat_survey: payload,
      });
      commit(types.SET_CSAT_SURVEY, data);
      return data;
    } finally {
      commit(types.SET_CSAT_SURVEY_UI_FLAG, { isUpdating: false });
    }
  },
  fetchFormats: async function fetchFormats({ commit }) {
    const { data } = await CsatSurveysAPI.formats();
    commit(types.SET_CSAT_FORMATS, data.payload);
  },
};

export const mutations = {
  [types.SET_CSAT_SURVEY_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_CSAT_SURVEYS](_state, data) {
    _state.records = data.reduce((acc, survey) => {
      acc[survey.id] = survey;
      return acc;
    }, {});
  },
  [types.SET_CSAT_SURVEY](_state, survey) {
    _state.records = { ..._state.records, [survey.id]: survey };
  },
  [types.SET_CSAT_FORMATS](_state, data) {
    _state.formats = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
